module.exports = __webpack_public_path__ + "media/5.d3a6bebb.mp3";